import { StaticContentRenderer } from '../StaticContentRenderer/StaticContentRenderer';
import type { StaticContent, StaticLookupRegistry } from '../types';

type StaticPageSectionContentProps = {
  content: StaticContent[];
  isNumbered: boolean;
  lookupData?: StaticLookupRegistry;
};

/**
 * Body of a {@link StaticPageSection}.
 *
 * Renders content as hierarchical numbered clauses, or as an unnumbered stack
 * when `isNumbered` is `false`. Renders nothing when there is no content.
 *
 * @param content - Content blocks from page JSON
 * @param isNumbered - Whether each block is a numbered clause
 * @param lookupData - Route-owned datasets referenced by lookup blocks
 */
function StaticPageSectionContent({ content, isNumbered, lookupData }: StaticPageSectionContentProps) {
  if (content.length === 0) {
    return null;
  }

  if (isNumbered) {
    return (
      <ol className="ol-hierarchical">
        {content.map((item, index) => (
          <li key={index}>
            <StaticContentRenderer content={item} lookupData={lookupData} />
          </li>
        ))}
      </ol>
    );
  }

  return (
    <div className="flex w-full flex-col gap-4">
      {content.map((item, index) => (
        <div key={index} className="w-full">
          <StaticContentRenderer content={item} lookupData={lookupData} />
        </div>
      ))}
    </div>
  );
}

export { StaticPageSectionContent, type StaticPageSectionContentProps };
